/* Shim for deprecated uvoAutocomplete. Only modifies html layout for compatibility */
$.fn.uvoAutocomplete =
  $.fn.uvoAutocomplete ||
  function() {
    return this.each(function(_, el) {
      if (el.uvoAutocompleteShimInitialized) return;
      el.uvoAutocompleteShimInitialized = true;
      const $el = $(el);
      const $wrapper = $('<div class="uvo_pref-uvoAutocomplete-wrapper" />');
      const $icon = $(
        '<span class="ui-icon ui-icon-triangle-1-s" style="position: absolute; cursor: pointer; right: 10px; top: 0px;" />',
      );
      $el.wrap($wrapper);
      $el.after($icon);
      $el.addClass('uvo_pref-uvoAutocomplete-input');
      $el.css({ appearance: 'none', '::-ms-expand': 'none' });
      $icon.css({ pointerEvents: 'none' });
    });
  };

document.addEventListener('DOMContentLoaded', function() {
  $(window).on('scroll', function() {
    if ($('body').hasClass('orderform-page')) {
      if ($('body').hasClass('sticky-menu-active')) {
        $('.rc-sticky-sidebar').css('margin-top', 90);
      } else {
        $('.rc-sticky-sidebar').css('margin-top', 'auto');
      }
    }
  });

  if ($('[data-calc-short]').length > 0 || $('[data-calc-mini]').length > 0) {
    $.getScript('/assets/js/calc.js', function() {
      defaultOptions = {
        deadlinesDefault: [140367],
        pagesDefault: 1,
        academicLevelDefault: 1,
        paperTypesDefault: 2,
      };

      if ($('[data-calc-short]').length > 0) {
        new Calc({
          ID: '109',
          calculatorType: 'ShortCalculator',
          format: 'json',
          options: {
            deafault: defaultOptions,
            currency: {
              decimalCurrency: true,
            },
          },
          callback() {
            $('.orderform-wrapper-inside .submitform').attr('disabled', false);
          },
        });
      }

      if ($('[data-calc-mini]').length > 0) {
        new Calc({
          ID: '109',
          calculatorType: 'DefaultCalculator',
          format: 'html',
          options: {
            deafault: defaultOptions,
            currency: {
              decimalCurrency: true,
              decimalUSDcurrency: true,
            },
          },
        });
      }
    });
  }
});

/**
 * Description: JS for
 * Version: 1.0.0
 * Last update: 2015/05/01
 * Author: UVOCorp
 *
 * Summary:

 *	2. Custom JS for

 *	19. javascript custom
 *
 *	20. theme.init.js
 */

/* ==========================================================================
   2. Custom JS for
   ========================================================================== */

$(function() {
  $('.testimonials-carousel').owlCarousel({
    items: 4,
    loop: true,
    nav: false,
    responsiveClass: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      980: {
        items: 3,
      },
      1024: {
        items: 4,
      },
    },
  });

  if ($.fn.uvoAutocomplete) {
    // add class "selected" for item select
    $('.place-your-order select, .styled-select select').uvoAutocomplete({
      onOpen(e) {
        const lebelEl = this.label;
        $(this._listElement.children()).each(function() {
          if ($(this).text() == lebelEl) {
            $(this).addClass('selected');
          }
        });
      },
      sortBy: 'none',
    });
    // count pages
    $.fn.counts = function(options) {
      // defaultOptions
      options = $.extend(
        {
          minusClass: 'pageskol-left',
          minimum: 1,
        },
        options,
      );
      const inputCol = $(this);
      if ($(inputCol).val() <= options.minimum) {
        $(`span[class=${options.minusClass}]`).css({
          opacity: '0.5',
          cursor: 'default',
        });
      } else {
        $(`span[class=${options.minusClass}]`).css({
          opacity: '1',
          cursor: 'pointer',
        });
      }
      $(inputCol)
        .parent()
        .find('span')
        .click(function() {
          if ($(this).hasClass(options.minusClass)) {
            if ($(inputCol).val() >= options.minimum) {
              var count = parseInt($(inputCol).val()) - 1;
              count = count < options.minimum ? options.minimum : count;
            } else {
              $(inputCol).val(options.minimum - 1);
              var count = parseInt($(inputCol).val()) - 1;
              count = count < options.minimum ? options.minimum : count;
            }
            if ($(inputCol).val() <= options.minimum + 1) {
              $(`span[class=${options.minusClass}]`).css({
                opacity: '0.5',
                cursor: 'default',
              });
            }
          } else {
            if ($(inputCol).val() >= options.minimum) {
              var count = parseInt($(inputCol).val()) + 1;
            } else {
              $(inputCol).val(options.minimum - 1);
              var count = parseInt($(inputCol).val()) + 1;
            }
            if ($(inputCol).val() > options.minimum - 1) {
              $(`span[class=${options.minusClass}]`).css({
                opacity: '1',
                cursor: 'pointer',
              });
            }
          }
          $(inputCol).val(count);
          $(inputCol).change();
          $(this)
            .parent()
            .next()
            .find('span')
            .html(275 * count);
          return false;
        });
      $(this).change(function(e) {
        let count = parseInt($(this).val());
        if (isNaN(count)) {
          count = 1;
          $(this).val(1);
        }
        $(this)
          .parent()
          .next()
          .find('span')
          .html(275 * count);
      });
      $(this).focusout(function(e) {
        let count = parseInt($(this).val());
        if (isNaN(count)) {
          count = 1;
          $(this).val(1);
        }
        $(this)
          .parent()
          .next()
          .find('span')
          .html(275 * count);
      });
      $(this).keydown(function(e) {
        if (
          e.which != 8 &&
          e.which != 0 &&
          (e.which < 37 || e.which > 57) &&
          e.which != 96 &&
          e.which != 97 &&
          e.which != 98 &&
          e.which != 99 &&
          e.which != 100 &&
          e.which != 101 &&
          e.which != 102 &&
          e.which != 103 &&
          e.which != 104 &&
          e.which != 105
        ) {
          return false;
        }
        let key;
        let keyChar;
        if (!e) var { e } = window;
        if (e.keyCode) key = e.keyCode;
        else if (e.which) key = e.which;
        if (key == 8) {
          return true;
        }
        if (
          key == 38 ||
          key == 39 ||
          ((e.which < 48 || e.which > 57) &&
            e.which != 96 &&
            e.which != 97 &&
            e.which != 98 &&
            e.which != 99 &&
            e.which != 100 &&
            e.which != 101 &&
            e.which != 102 &&
            e.which != 103 &&
            e.which != 104 &&
            e.which != 105)
        ) {
          if (key == 40 || key == 37) {
            if ($(this).val() >= options.minimum) {
              var count = parseInt($(this).val()) - 1;
              count = count < options.minimum ? options.minimum : count;
            } else {
              $(this).val(options.minimum - 1);
              keyChar = String.fromCharCode(key);
              var count = parseInt($(this).val()) + 1;
            }
          } else if ($(this).val() >= options.minimum) {
            var count = parseInt($(this).val()) + 1;
          } else {
            $(this).val(options.minimum - 1);
            var count = parseInt($(this).val()) + 1;
          }
          $(this).val(count);
          $(this)
            .parent()
            .next()
            .find('span')
            .html(275 * count);
          if ($(inputCol).val() <= options.minimum) {
            $(`span[class=${options.minusClass}]`).css({
              opacity: '0.5',
              cursor: 'default',
            });
          } else {
            $(`span[class=${options.minusClass}]`).css({
              opacity: '1',
              cursor: 'pointer',
            });
          }
        }
      });
    };
    // counts
    $('#input-kol').counts();
  }
  // toplink click
  $('.totop-link').click(function() {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      800,
    );
    return false;
  });

  $('.show-hide')
    .find('.hidden')
    .hide();
  $('#inq-done-more').click(function() {
    if (!$(this).hasClass('less')) {
      $(this)
        .parents('.show-hide')
        .find('.hidden')
        .slideDown(500);
      $(this)
        .text('Read less')
        .addClass('less');
    } else {
      $(this)
        .parents('.show-hide')
        .find('.hidden')
        .slideUp(500);
      $(this)
        .text('Read more')
        .removeClass('less');
    }
  });
  const pl_panel = $('.plagcheckc aside#rightplagpanel').clone();
  $(pl_panel)
    .removeAttr('id')
    .appendTo('.plagcheckc')
    .attr('id', 'rightplagpanel_2');
});

/* ==========================================================================
   19. javascript custom
   ========================================================================== */
// Add here all your JS customizations
$(document).ready(function() {
  // my fixed scroll menu
  function fixed_scroll_menu() {
    const $scr = $(window).scrollTop();
    const heightsrc = $(window).scrollTop();
    const heightdoc = $(window).height();
    const headersrc = $('#header').height();
    if ($(window).innerWidth() > 500) {
      var scr = 40;
    } else {
      var scr = 44;
    }
    if ($scr > scr) {
      $('body').removeClass('sticky-menu-deactive');
      $('body').addClass('sticky-menu-active');
      $('body #h-content').css('padding-top', '128px');
      $('#header > .container').addClass('sticky-header');
      $('header .logo').addClass('logo-sticky-active');

      $('.logo-img').css('display', 'inline-block');
      $('.logo-img').css('width', '200px');
      $('.logo-img').css('height', '80px');
      $('.logo-img').css('top', '28px');
    } else {
      $('body').css('padding-top', 0);
      $('body').addClass('sticky-menu-deactive');
      $('.rc-sticky-sidebar').css('margin-top', 0);
      $('body').removeClass('sticky-menu-active');
      $('body #h-content').css('padding-top', '0px');
      $('#header > .container').removeClass('sticky-header');
      $('header .logo').removeClass('logo-sticky-active');

      $('.logo-img').css('display', 'inline-block');
      $('.logo-img').css('width', '250px');
      $('.logo-img').css('height', '100px');
      $('.logo-img').css('top', '0px');
    }
  }

  fixed_scroll_menu();

  $(window).scroll(function() {
    fixed_scroll_menu();
  });

  $(window).resize(function() {
    fixed_scroll_menu();
  });

  // fade in #back-top
  function f_to_top() {
    if ($(window).innerWidth() > 812) {
      if ($(this).scrollTop() > 100) {
        $('#back-top').fadeIn();
      } else {
        $('#back-top').fadeOut();
      }
    } else if ($(this).scrollTop() > 100) {
      $('#back-top').show();
    } else {
      $('#back-top').hide();
    }
  }
}); // doc-red

/* ==========================================================================
   20. theme.init.js
   ========================================================================== */
// Commom Plugins
(function($) {
  // Parallax
  if (typeof theme.PluginParallax !== 'undefined') {
    theme.PluginParallax.initialize();
  }

  // Tooltips
  if ($.isFunction($.fn.tooltip)) {
    $('[data-tooltip]').tooltip();
  }
}.apply(this, [jQuery]));

// Animate
(function($) {
  if ($.isFunction($.fn.themePluginAnimate)) {
    $(function() {
      $('[data-plugin-animate], [data-appear-animation]').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginAnimate(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Chart.Circular
(function($) {
  if ($.isFunction($.fn.themePluginChartCircular)) {
    $(function() {
      $('[data-plugin-chart-circular]:not(.manual), .circular-bar-chart:not(.manual)').each(
        function() {
          const $this = $(this);
          let opts;

          const pluginOptions = $this.data('plugin-options');
          if (pluginOptions) opts = pluginOptions;

          $this.themePluginChartCircular(opts);
        },
      );
    });
  }
}.apply(this, [jQuery]));

// Counter
(function($) {
  if ($.isFunction($.fn.themePluginCounter)) {
    $(function() {
      $('[data-plugin-counter]:not(.manual), .counters [data-to]').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginCounter(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Flickr
(function($) {
  if ($.isFunction($.fn.themePluginFlickr)) {
    $(function() {
      $('[data-plugin-flickr]:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginFlickr(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Lightbox
(function($) {
  if ($.isFunction($.fn.themePluginLightbox)) {
    $(function() {
      $('[data-plugin-lightbox]:not(.manual), .lightbox:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginLightbox(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Masonry
(function($) {
  if ($.isFunction($.fn.themePluginMasonry)) {
    $(function() {
      $('[data-plugin-masonry]:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginMasonry(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Progress Bar
(function($) {
  if ($.isFunction($.fn.themePluginProgressBar)) {
    $(function() {
      $('[data-plugin-progress-bar]:not(.manual), [data-appear-progress-animation]').each(
        function() {
          const $this = $(this);
          let opts;

          const pluginOptions = $this.data('plugin-options');
          if (pluginOptions) opts = pluginOptions;

          $this.themePluginProgressBar(opts);
        },
      );
    });
  }
}.apply(this, [jQuery]));

// Revolution Slider
(function($) {
  if ($.isFunction($.fn.themePluginRevolutionSlider)) {
    $(function() {
      $(
        '[data-plugin-revolution-slider]:not(.manual), .slider-container .slider:not(.manual)',
      ).each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginRevolutionSlider(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Sort
(function($) {
  if ($.isFunction($.fn.themePluginSort)) {
    $(function() {
      $('[data-plugin-sort]:not(.manual), .sort-source:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginSort(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Toggle
(function($) {
  if ($.isFunction($.fn.themePluginToggle)) {
    $(function() {
      $('[data-plugin-toggle]:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginToggle(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Tweets
(function($) {
  if ($.isFunction($.fn.themePluginTweets)) {
    $(function() {
      $('[data-plugin-tweets]:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginTweets(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Video Background
(function($) {
  if ($.isFunction($.fn.themePluginVideoBackground)) {
    $(function() {
      $('[data-plugin-video-background]:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginVideoBackground(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Word Rotate
(function($) {
  if ($.isFunction($.fn.themePluginWordRotate)) {
    $(function() {
      $('[data-plugin-word-rotate]:not(.manual), .word-rotate:not(.manual)').each(function() {
        const $this = $(this);
        let opts;

        const pluginOptions = $this.data('plugin-options');
        if (pluginOptions) opts = pluginOptions;

        $this.themePluginWordRotate(opts);
      });
    });
  }
}.apply(this, [jQuery]));

// Commom Partials
(function($) {
  // Sticky Menu
  if (typeof theme.StickyMenu !== 'undefined') {
    theme.StickyMenu.initialize();
  }

  // Nav Menu
  if (typeof theme.Nav !== 'undefined') {
    theme.Nav.initialize();
  }

  // Search
  if (typeof theme.Search !== 'undefined') {
    theme.Search.initialize();
  }

  // Newsletter
  if (typeof theme.Newsletter !== 'undefined') {
    theme.Newsletter.initialize();
  }

  // Account
  if (typeof theme.Account !== 'undefined') {
    theme.Account.initialize();
  }
}.apply(this, [jQuery]));

/* a new js for header */
$(function() {
  let wWidth = $(document).width();
  const $classMenu = $('.menu');
  const $body = $('body');

  addClassMenu();
  main();

  $(window).on('resize', function() {
    addClassMenu();
    main();
  });

  function addClassMenu() {
    wWidth = $(document).width();
    if (wWidth <= 991) {
      $classMenu.addClass('mobile-left');
    } else if (wWidth > 991 && $classMenu.hasClass('mobile-left')) {
      $classMenu.removeClass('mobile-left');
    }
  }

  // animate function for header menu
  function main() {
    let serviceNavIsOpen = false;

    function serviceNavOpen() {
      if ($('.nav-main-collapse').hasClass('show')) {
        $('.btn-responsive-nav').trigger('click');
      }

      $('.menu').addClass('animate');
      $('body').addClass('animate');
      serviceNavIsOpen = true;
    }

    function serviceNavClose() {
      $('.menu').removeClass('animate');
      $('body').removeClass('animate');
      serviceNavIsOpen = false;
    }

    wWidth = $(document).width();
    if (wWidth <= 991) {
      $('.icon-menu').bind('click', serviceNavOpen);
      $('.icon-close').bind('click', serviceNavClose);
    } else {
      $('.icon-menu').off('click');
      $('.icon-close').off('click');
    }

    $('.btn-responsive-nav').click(function() {
      if (serviceNavIsOpen && !$(this).hasClass('collapsed')) {
        serviceNavClose();
      }
    });

    $(window).resize(function() {
      if ($(window).width() > 991 && serviceNavIsOpen) {
        serviceNavClose();
      }
    });
  }
});

(function toggleListInit() {
  if (
    !document.querySelector('.faq-section') &&
    !document.querySelector('[data-page="frequently_asked_questions"]') &&
    !document.querySelector('[data-page="money_back_guarantee"]')
  ) {
    return false;
  }

  function toggle_list() {
    $('.toggle-list .toggle-content').addClass('hide');
    $(document).on('click', '.toggle-list .toggle-link', function() {
      if (
        $(this)
          .next()
          .hasClass('hide')
      ) {
        $(this)
          .next()
          .slideDown(500);
      } else {
        $(this)
          .next()
          .slideUp(500);
      }
      $(this)
        .parent()
        .toggleClass('active');
      $(this)
        .next()
        .toggleClass('hide');
      return false;
    });
  }

  if (document.querySelector('.faq-section')) {
    document.addEventListener('DOMContentLoaded', toggle_list);
  } else {
    window.addEventListener('contentRendered', toggle_list);
  }
})();

(function(window, document) {
  function init() {
    const element = document.getElementById('CommonPage');

    if (element) {
      const pageName = element.getAttribute('data-page');
      const siteId = element.getAttribute('data-site-id');
      const policies = element.getAttribute('data-policies');
      const policyId = element.getAttribute('data-policy-id');

      let widgetOptions = {
        siteId,
        pageName,
      };

      if (policies && policyId) {
        widgetOptions = { siteId, pageName, policies, policyId };
      }

      window.commonPagesWidget.widget(element, widgetOptions);
    }
  }

  if (typeof window.commonPagesWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/commonPagesWidget.min.js';
    script.async = true;
    script.onload = function() {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);

(function(window, document) {
  function init() {
    window.NotifyWidget({
      siteId: '109',
      container: '.NotifyWidget-banner',
    });
  }

  if (typeof window.NotifyWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/notifyWidget.min.js';
    script.async = true;
    script.onload = function() {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);
